import styled from 'styled-components';
import { widthMultiplier } from './constants';

// Reminder Common UI Dialog box heigh is 0.75 * window.innerHeight
const height = 0.71 * window.innerHeight;

export const FormBody = styled.div<{
  printView?: boolean;
  dialogHeight?: boolean;
}>`
  ${(props: any) =>
    props.printView
      ? `margin-bottom: 20px;
         padding-left: 2%;`
      : `
  background-color: ${props.theme.palette.form.background};
  width: 100%;
  height: 100%;`}
  color: ${(props: any) => props.theme.palette.form.text.primary};
  ${(props: any) =>
    props.dialogHeight
      ? `height: ${height}px;
         padding-left: 2%;`
      : `;`}
    @media print {
    color: black;
  }
`;

export const TopFormSection = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 10px 0px;
  width: 100%;
  position: sticky;
  top: 0;
  z-index: 2;
  ${(props: any) => `background-color: ${props.theme.palette.form.background};`}
`;
export const TopForm = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 10px 0px;
  width: 100%;
  flex-wrap: wrap;
  ${(props: any) =>
    `background-color: ${props.theme.palette.form.background};`};
`;

export const Text = styled.div<{
  width?: number;
}>`
  display: flex;
  justify-content: flex-start;
  align-content: flex-start;
  align-items: flex-start;
  padding-right: 6px;
  ${(props: any) =>
    props.width
      ? `flex-basis: ${props.width * widthMultiplier}px; flex-shrink: 0`
      : `;`}
`;

export const DCDiv = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  width: 100%;
  ${(props: any) => {
    const { background } = props.theme.palette.form;
    return `color: ${background}`;
  }}
`;

export const StyledLi = styled.li<{
  dc?: boolean;
  horizontal?: boolean;
  noBullet?: boolean;
}>`
  ${(props: any) => (props.horizontal ? `display: flex;` : `;`)}
  ${(props: any) => {
    const { secondary } = props.theme.palette.form.text;
    const { background } = props.theme.palette.form;
    return props.dc
      ? `color: ${background};
      background-color: ${secondary};
      display: flex;
      &:before {
    content: '• ';
    font-size: large;
    color: ${background};
  }`
      : `color: ${secondary};
      &:before {
    content: '• ';
    font-size: large;
    color: ${secondary};
  }`;
  }}
  ${(props: any) => {
    const { secondary } = props.theme.palette.form.text;
    return props.noBullet
      ? `color: ${secondary};
      &:before {
    content: '';
    color: ${secondary};
  }`
      : ';';
  }}
  padding: 3px;
  @media print {
    color: black;
  }
`;
// pre-line to get line breaks
export const StyledDiv = styled.div<{
  dc?: boolean;
  horizontal?: boolean;
}>`
  ${(props: any) => (props.horizontal ? `display: flex;` : `;`)}
  ${(props: any) => {
    const { secondary } = props.theme.palette.form.text;
    const { background } = props.theme.palette.form;
    return props.dc
      ? `color: ${background};
      background-color: ${secondary};
      display: flex;`
      : `color: ${secondary};`;
  }}
  align-items: center;
  padding: 3px;
  white-space: pre-line;
  @media print {
    color: black;
  }
`;

export const InputDiv = styled.div`
  padding: 3px;
`;
export const SignatureDiv = styled.div`
  padding: 10px;
`;

export const FormLi = styled.li<{
  horizontal?: boolean;
  bullet?: boolean;
  readOnly?: boolean;
}>`
  width: 100%;
  ${(props: any) => (props.horizontal ? `display: flex;` : `;`)}
    ${(props: any) => {
      const { secondary } = props.theme.palette.form.text;
      return props.readOnly ? `color: ${secondary};` : `;`;
    }}
  ${(props: any) =>
    props.bullet
      ? `display: flex;
      padding-left: 30px;
      &:before {
    content: '• ';
    font-size: large;
  }`
      : `;`};
`;

export const StyledUl = styled.ul<{
  horizontal?: boolean;
}>`
  list-style-type: none;
  padding-inline-start: 5px;
  ${(props: any) =>
    props.horizontal
      ? `display: flex;align-items: flex-start; flex-wrap: wrap`
      : `;`}
`;
export const StyledReadOnlyUl = styled.ul<{
  horizontal?: boolean;
}>`
  list-style-type: none;
  padding-inline-start: 5px;
  ${(props: any) => (props.horizontal ? `display: flex;` : `;`)}
`;

export const ElementDiv = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
  flex-wrap: nowrap;
`;

export const SignatureForm = styled.div<{
  readOnly?: boolean;
}>`
  max-width: 300px;
  padding: 5px;
  margin: 10px 0px;
  ${(props: any) => (props.readOnly ? `border: 1px solid black;` : `;`)}
`;
export const PainMapCanvas = styled.div<{
  validated?: boolean;
}>`
  ${(props: any) => (props.validated ? `border: 2px solid blue;` : `;`)}
`;

export const FullWidthLi = styled.li`
  width: 100%;
`;
export const FormNameDiv = styled.div`
  font-size: 1.2rem;
  font-weight: 600;
`;
// todo in common-ui styled div
export const SavingDiv = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  background-color: rgba(129, 199, 132, 0.5);
  color: white;
  min-height: 30px;
  height: 80%;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  -webkit-border-radius: 4px;
`;

export const TitleDiv = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
  padding: 10px 0px;
`;
export const StickyTitleDiv = styled.div<{
  stickyElHeight?: number;
}>`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
  padding: 10px 0px;
  position: sticky;
  z-index: 2;
  background-color: #e5efff;
  ${(props: any) => `top: ${props.stickyElHeight - 1}px;`};
`;
